import React, { useState, useContext, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { AHRIInfoServiceCall } from "../../../../services/services";
import { EWContext } from "../../../../context/EWContext";
import { Fragment } from "react";
import Backdrop from "../../../../hoc/Backdrop/Backdrop";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { LANGUAGE_TEXT } from "../../../../constants";

function AHRILookup(props) {
   const accountState = useContext(EWContext)[0];

   const { customErrors, baseUrl, pimcore } = accountState;

   const { onAHRILookUp, ahriNumberValue, question } = props;

   const [value, setValue] = useState(ahriNumberValue);
   const [error, setError] = useState({ error: false, errorMessage: "" });
   const [loadingData, setLoadingData] = useState(false);
   const QUESTION_DEFAULT = {
      id: "ahri_number",
      name: "ahri_number",
      label: accountState?.conditionSpecificBehaviors?.translateText && accountState?.storeInfo?.languageCode
         ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]?.ahri_auto_fill
         : "Enter AHRI Number, to autofill product info below.",
      summaryLabel: "AHRI Number",
      summaryOrder: 1,
      required: false,
      group: "ahri",
      position: 0,
      placeholder: "Type an AHRI Number",
      note: accountState?.customMessages?.AHRINote,
      field: {
         type: "text",
         showOnSummary: true,
         values: [],
         validators: [],
         errorMessages: [],
      },
   };
   const [ahriQuestion] = useState(question || QUESTION_DEFAULT);
   useEffect(() => {
      setError({ error: false, errorMessage: "" });
      let delayDebounceFn;
      if (value.length > 0) {
         delayDebounceFn = setTimeout(() => {
            getAHRIInfo(value);
         }, 1800);
      }
      return () => clearTimeout(delayDebounceFn);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value]);

   const getAHRIInfo = async (AHRINumber) => {
      setLoadingData(true);
      const modelsResponse = await AHRIInfoServiceCall(
         baseUrl,
         AHRINumber,
         pimcore?.categoryLabel,
         customErrors.genericError
      ).catch((error) => {
         console.log(error);
         setLoadingData(false);
         return;
      });
      const AHRIQuestion = ahriQuestion;
      try {
         const AHRIInformation = modelsResponse[0];
         setLoadingData(false);
         if (AHRIInformation && AHRIInformation.length > 0) {
            onAHRILookUp({
               AHRINumber,
               AHRIInformation: AHRIInformation[0],
               AHRIQuestion,
            });
         } else {
            onAHRILookUp({
               AHRINumber,
               AHRIQuestion,
               AHRIInformation: null,
            });
            setError({
               error: true,
               errorMessage: `Sorry. no results found for "${AHRINumber}"`,
            });
         }
      } catch (error) {
         console.log(error);
         setLoadingData(false);
         onAHRILookUp({
            AHRINumber,
            AHRIQuestion,
            error: { error: true, ...error },
         });
         setError({
            error: true,
            errorMessage: `Sorry. no results found for "${AHRINumber}"`,
         });
      }
   };

   const handleClickCleanField = () => {
      setValue("");
      onAHRILookUp({
         AHRINumber: "",
         AHRIQuestion: question || QUESTION_DEFAULT,
      });
   };

   const handleMouseDownClean = (event) => {
      event.preventDefault();
   };

   return (
      <Fragment>
         <Backdrop open={loadingData} />
         <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
               <TextField
                  id={ahriQuestion.id}
                  fullWidth
                  label={ahriQuestion.label}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                     disableUnderline: true,
                     endAdornment: (
                        <InputAdornment position="end">
                           {value.length > 0 ? (
                              <IconButton
                                 aria-label="clear AHRI number"
                                 onClick={handleClickCleanField}
                                 onMouseDown={handleMouseDownClean}
                              >
                                 <ClearOutlinedIcon />
                              </IconButton>
                           ) : (
                              <SearchOutlinedIcon color="disabled" />
                           )}
                        </InputAdornment>
                     ),
                  }}
                  value={value}
                  placeholder={ahriQuestion.placeholder}
                  onChange={(e) => setValue(e.target.value)}
                  error={error.error}
                  helperText={error.error ? error.errorMessage : ""}
               />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
               <Box mx="auto" p={3}>
                  <Typography variant="body2">
                     <div dangerouslySetInnerHTML={{ __html: ahriQuestion.note }} />
                  </Typography>
               </Box>
            </Grid>
            <Grid item xs={12}>
               <Box pb={2}>
                  <Divider variant="fullWidth" />
               </Box>
            </Grid>
         </Grid>
      </Fragment>
   );
}

export default AHRILookup;
